(() => {
  const key = 'vireano-cart-reservation-end';
  const duration = 10 * 60 * 1000;
  const getEnd = () => {
    const saved = Number(sessionStorage.getItem(key));
    if (saved > Date.now()) return saved;
    const next = Date.now() + duration;
    sessionStorage.setItem(key, String(next));
    return next;
  };
  let end = getEnd();

  const updateTimer = () => {
    let remaining = Math.max(0, end - Date.now());
    if (remaining === 0) {
      end = Date.now() + duration;
      sessionStorage.setItem(key, String(end));
      remaining = duration;
    }
    const seconds = Math.floor(remaining / 1000);
    const label = `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
    document.querySelectorAll('[data-vc-timer]').forEach((node) => { node.textContent = label; });
  };

  const renderCart = (state) => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
  };

  const syncCartCount = () => {
    const badge = document.querySelector('[data-vn-cart-count]');
    if (!badge) return;
    const total = [...document.querySelectorAll('cart-drawer input[name="updates[]"]')]
      .reduce((sum, input) => sum + (Number(input.value) || 0), 0);
    badge.textContent = total;
    badge.hidden = total === 0;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vc-upsell]');
    if (!button || button.disabled) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.vcUpsell), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      });
      const state = await response.json();
      if (!response.ok) throw new Error(state.description || 'Toevoegen is niet gelukt.');
      renderCart(state);
    } catch (error) {
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = error.message;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  updateTimer();
  syncCartCount();
  const drawer = document.querySelector('cart-drawer');
  if (drawer) new MutationObserver(syncCartCount).observe(drawer, { childList: true, subtree: true });
  window.setInterval(updateTimer, 1000);
})();
